/* =============================================================================
   Diamore — Página Personalizado
   Multi-step form logic + CF Worker submit
   ============================================================================= */

(function () {
  'use strict';

  var TOTAL_STEPS = 3;
  var currentStep = 1;

  // ── DOM references ──────────────────────────────────────────────────────────

  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  var stepper    = $('.pers-stepper');
  var panels     = $$('.pers-panel');
  var submitBtn  = $('#pers-submit-btn');
  var msgSuccess = $('#pers-msg-success');
  var msgError   = $('#pers-msg-error');

  // ── Step navigation ─────────────────────────────────────────────────────────

  function showStep(n) {
    currentStep = n;

    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.step === String(n));
    });

    if (stepper) {
      $$('.pers-stepper__step', stepper).forEach(function (step) {
        var num = parseInt(step.dataset.stepNum, 10);
        step.classList.remove('pers-stepper__step--active', 'pers-stepper__step--done');
        if (num === n) {
          step.classList.add('pers-stepper__step--active');
        } else if (num < n) {
          step.classList.add('pers-stepper__step--done');
        }
      });
    }

    if (n === 3) updateSummary();

    var anchor = $('.pers-stepper');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Step validation ─────────────────────────────────────────────────────────

  function validateStep(stepIndex) {
    var valid = true;
    var errors = [];

    if (stepIndex === 0) {
      var tipoSelected = document.querySelector('.pers-type-card.is-selected');
      if (!tipoSelected) {
        valid = false;
        var cardsContainer = document.querySelector('.pers-type-grid');
        if (cardsContainer) {
          cardsContainer.style.outline = '1.5px solid #C0392B';
          cardsContainer.style.outlineOffset = '4px';
          var errId = 'pers-type-error';
          if (!document.getElementById(errId)) {
            var err = document.createElement('p');
            err.id = errId;
            err.textContent = '✦ Selecciona el tipo de pieza para continuar';
            err.style.cssText = 'color:#C0392B;font-family:"Josefin Sans",sans-serif;font-size:10px;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:12px;text-align:center;';
            cardsContainer.parentElement.insertBefore(err, cardsContainer);
          }
          cardsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () {
            cardsContainer.style.outline = '';
            cardsContainer.style.outlineOffset = '';
            var e = document.getElementById(errId);
            if (e) e.remove();
          }, 4000);
        }
      }
      var desc = document.getElementById('pers-description');
      if (desc && !desc.value.trim()) {
        valid = false;
        desc.style.borderColor = '#C0392B';
        errors.push({ msg: 'Describe tu visión', target: '#pers-description' });
      } else if (desc) {
        desc.style.borderColor = '';
      }
    }

    if (stepIndex === 1) {
      var metalSelected = document.querySelector('#pg-metal .pers-pill.is-selected');
      if (!metalSelected) {
        valid = false;
        errors.push({ msg: 'Selecciona un metal', target: '#pg-metal' });
      }
      var stoneSelected = document.querySelector('#pg-stone-grid .pers-stone-card.is-selected');
      if (!stoneSelected) {
        valid = false;
        errors.push({ msg: 'Selecciona una piedra principal', target: '#pg-stone-grid' });
      }
      var budgetSelected = document.querySelector('.pers-budget-chip.is-selected, #pg-budget .is-selected');
      var budgetInput = document.getElementById('pers-budget');
      var hasBudget = budgetSelected || (budgetInput && budgetInput.value && budgetInput.value !== 'no-indicar');
      if (!hasBudget) {
        valid = false;
        var budgetContainer = document.getElementById('pg-budget') || document.querySelector('.pers-budget-section');
        if (budgetContainer) {
          budgetContainer.style.outline = '1.5px solid #C0392B';
          budgetContainer.style.outlineOffset = '4px';
          setTimeout(function () {
            budgetContainer.style.outline = '';
            budgetContainer.style.outlineOffset = '';
          }, 3000);
        }
        errors.push({ msg: 'Selecciona un presupuesto', target: '#pg-budget' });
      }
    }

    if (stepIndex === 2) {
      ['pers-name', 'pers-phone', 'pers-email'].forEach(function (id) {
        var field = document.getElementById(id);
        if (field && !field.value.trim()) {
          valid = false;
          field.style.borderColor = '#C0392B';
        } else if (field) {
          field.style.borderColor = '';
        }
      });
    }

    if (!valid && errors.length > 0) {
      var targetEl = document.querySelector(errors[0].target);
      if (targetEl) {
        var errEl = targetEl.parentElement && targetEl.parentElement.querySelector('.pers-step-error');
        if (!errEl) {
          errEl = document.createElement('p');
          errEl.className = 'pers-step-error';
          errEl.style.cssText = 'color:#C0392B;font-family:"Josefin Sans",sans-serif;font-size:11px;letter-spacing:1px;text-transform:uppercase;margin-top:8px;';
          targetEl.parentElement && targetEl.parentElement.insertBefore(errEl, targetEl.nextSibling);
        }
        errEl.textContent = errors[0].msg;
        setTimeout(function () { if (errEl.parentElement) errEl.remove(); }, 3000);
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    return valid;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-step-next]')) {
      if (currentStep < TOTAL_STEPS) {
        if (!validateStep(currentStep - 1)) return;
        showStep(currentStep + 1);
      }
    }
    if (e.target.closest('[data-step-prev]')) {
      if (currentStep > 1) showStep(currentStep - 1);
    }
  });

  if (stepper) {
    $$('.pers-stepper__step', stepper).forEach(function (step) {
      step.addEventListener('click', function () {
        var num = parseInt(step.dataset.stepNum, 10);
        if (num < currentStep) showStep(num);
      });
    });
  }

  // ── Type selector cards ─────────────────────────────────────────────────────

  var typeCards      = $$('.pers-type-card');
  var pieceTypeInput = $('#pers-piece-type');

  typeCards.forEach(function (card) {
    card.addEventListener('click', function () {
      typeCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      if (pieceTypeInput) pieceTypeInput.value = card.dataset.value;
    });
  });

  // ── Pills multi-select (metal, shape) ───────────────────────────────────────

  $$('.pers-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      pill.classList.toggle('is-selected');
      updatePillValues(pill.closest('.pers-pills-group'));
    });
  });

  function updatePillValues(group) {
    if (!group) return;
    var input = group.querySelector('input[type="hidden"]');
    if (!input) {
      // Hidden inputs live at form level; derive ID from group id (pg-metal → pers-metal)
      var hiddenId = group.id ? group.id.replace(/^pg-/, 'pers-') : null;
      if (hiddenId) input = document.getElementById(hiddenId);
    }
    if (!input) return;
    var selected = $$('.pers-pill.is-selected', group).map(function (p) {
      return p.dataset.value;
    });
    input.value = selected.join(',');
  }

  // ── Stone grid single-select ─────────────────────────────────────────────────

  var stoneCards  = $$('.pers-stone-card');
  var stoneInput  = $('#pers-stone');

  stoneCards.forEach(function (card) {
    card.addEventListener('click', function () {
      stoneCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      if (stoneInput) stoneInput.value = card.dataset.value;
    });
  });

  // ── Budget chips single-select ───────────────────────────────────────────────

  var budgetChips = $$('.pers-budget-chip');
  var budgetInput = $('#pers-budget');

  budgetChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      budgetChips.forEach(function (c) { c.classList.remove('is-selected'); });
      chip.classList.add('is-selected');
      if (budgetInput) budgetInput.value = chip.dataset.value;
    });
  });

  // ── Dynamic summary (step 3) ─────────────────────────────────────────────────

  var STONE_LABELS = {
    'diamante-lab':     'Diamante Lab-Grown',
    'diamante-natural': 'Diamante Natural',
    'rubi':             'Rubí',
    'zafiro':           'Zafiro',
    'esmeralda':        'Esmeralda',
    'otro':             'Otro'
  };

  var BUDGET_LABELS = {
    '2000-4000':  '$2,000 — $4,000',
    '4000-8000':  '$4,000 — $8,000',
    '8000-15000': '$8,000 — $15,000',
    '15000+':     '$15,000+',
    'no-indicar': 'Prefiero no indicar'
  };

  var PIECE_LABELS = {
    'anillo-compromiso': 'Anillo de compromiso',
    'banda-matrimonio':  'Banda de matrimonio',
    'collar-colgante':   'Collar / colgante',
    'aretes-pulsera':    'Aretes / pulsera'
  };

  function updateSummary() {
    var summary = $('#pers-summary-preview');
    if (!summary) return;

    var piece  = getVal('pers-piece-type');
    var stone  = getVal('pers-stone');
    var budget = getVal('pers-budget');

    var rows = [];
    if (piece)  rows.push({ label: 'Pieza',       value: PIECE_LABELS[piece]   || piece });
    if (stone)  rows.push({ label: 'Piedra',       value: STONE_LABELS[stone]  || stone });
    if (budget) rows.push({ label: 'Presupuesto',  value: BUDGET_LABELS[budget] || budget });

    if (!rows.length) { summary.innerHTML = ''; return; }

    summary.innerHTML =
      '<div class="pers-summary-list">' +
      rows.map(function (r) {
        return '<div class="pers-summary-row">' +
          '<span class="pers-summary-row__label">' + r.label + '</span>' +
          '<span class="pers-summary-row__value">' + r.value + '</span>' +
          '</div>';
      }).join('') +
      '</div>';
  }

  // ── Contact preference ──────────────────────────────────────────────────────

  var contactOpts      = $$('.pers-contact-opt');
  var contactPrefInput = $('#pers-contact-pref');

  contactOpts.forEach(function (opt) {
    opt.addEventListener('click', function () {
      contactOpts.forEach(function (o) { o.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
      if (contactPrefInput) contactPrefInput.value = opt.dataset.value;
    });
  });

  // ── Form submit ─────────────────────────────────────────────────────────────

  var form = $('#pers-form');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var workerUrl = (window.cfWorkerUrl || '').replace(/\/$/, '');
      if (!workerUrl) {
        showError('Servicio de contacto no configurado. Por favor escríbenos directamente.');
        return;
      }

      var data = {
        name:               getVal('pers-name'),
        phone:              getVal('pers-phone'),
        email:              getVal('pers-email'),
        contact_preference: getVal('pers-contact-pref'),
        piece_type:         getVal('pers-piece-type'),
        description:        getVal('pers-description'),
        occasion:           getVal('pers-occasion'),
        deadline:           getVal('pers-deadline'),
        metal:              getVal('pers-metal'),
        stone:              getVal('pers-stone'),
        shape:              getVal('pers-shape'),
        budget:             getVal('pers-budget'),
        context:            'personalizado'
      };

      // Validar campos required
      var requiredFields = form.querySelectorAll('[required]');
      var hasEmpty = false;
      requiredFields.forEach(function(field) {
        var wrapper = field.closest('.pers-field, [class*="pers-field"]');
        if (!field.value.trim()) {
          field.classList.add('pers-field--error');
          hasEmpty = true;
          if (wrapper) {
            var err = wrapper.querySelector('.pers-error');
            if (!err) {
              err = document.createElement('span');
              err.className = 'pers-error';
              err.textContent = 'Este campo es obligatorio';
              err.style.cssText = 'color:#C0392B;font-size:11px;letter-spacing:1px;font-family:"Josefin Sans",sans-serif;text-transform:uppercase;display:block;margin-top:4px;';
              wrapper.appendChild(err);
            }
          }
        } else {
          field.classList.remove('pers-field--error');
          if (wrapper) wrapper.querySelector('.pers-error')?.remove();
        }
        field.addEventListener('input', function() {
          if (field.value.trim()) {
            field.classList.remove('pers-field--error');
            if (wrapper) wrapper.querySelector('.pers-error')?.remove();
          }
        }, { once: true });
      });

      if (!data.name || !data.phone || !data.email) {
        showStep(3);
        showError('Por favor completa nombre, teléfono y email.');
        return;
      }
      if (hasEmpty) {
        showError('Por favor completa todos los campos obligatorios.');
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Enviando...';
      }

      fetch(workerUrl + '/lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function () {
          // Notificar al ERP (fire-and-forget — nunca bloquea el submit)
          fetch('https://diamore-erp-worker.diamorejoyeros.workers.dev/personalizado/incoming', {
            method: 'POST',
            headers: {
              'Content-Type':  'application/json',
              'Authorization': 'Bearer diamore_erp_2026_secret'
            },
            body: JSON.stringify({
              nombre:      data.name,
              email:       data.email,
              tipo_pieza:  data.piece_type,
              presupuesto: data.budget,
              descripcion: data.description
            })
          }).catch(function () {});

          showSuccess();
        })
        .catch(function (err) {
          console.error('[personalizado] submit error:', err);
          showError('Ocurrió un error al enviar. Por favor inténtalo de nuevo o escríbenos por WhatsApp.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Enviar solicitud →';
          }
        });
    });
  }

  function getVal(id) {
    var el = document.getElementById(id);
    return el ? (el.value || '').trim() : '';
  }

  function showSuccess() {
    var submitArea = $('.pers-submit__inner');
    if (!submitArea) return;
    submitArea.innerHTML =
      '<div class="pers-message pers-message--success is-visible">' +
      '<strong style="display:block;margin-bottom:8px;font-family:var(--dm-font-serif);font-size:20px;">¡Solicitud enviada!</strong>' +
      'Te contactaremos en menos de 24 horas. Mientras tanto, puedes seguirnos en Instagram para inspirarte.' +
      '</div>';
  }

  function showError(msg) {
    if (msgError) {
      msgError.textContent = msg;
      msgError.classList.add('is-visible');
      if (msgSuccess) msgSuccess.classList.remove('is-visible');
      setTimeout(function () { msgError.classList.remove('is-visible'); }, 8000);
    }
  }

  // ── Init ────────────────────────────────────────────────────────────────────

  showStep(1);

})();
